query LinksFilter($scenarioId: ID!, $filterId: ID, $pagination: PaginationInput) {
  filter(scenarioId: $scenarioId) {
    links(filterId: $filterId, pagination: $pagination) {
      items {
        id
        code
        vacancies
        bundle {
          term {
            code
          }
        }
        course {
          id
          name
          code
          courseComponents {
            id
            component {
              id
              code
              name
            }
          }
          curriculum {
            program {
              campus {
                id
                name
                code
              }
            }
          }
        }
        sectionsCount
        totalBlocks
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        page
        size
        total
        __typename
      }
      __typename
    }
    __typename
  }
}
